export default [
  {
    label: '未接單',
    value: 'pending',
    colorText: 'orange',
    backgroundColor: 'rgba(255, 165, 0, 0.1)',
  },
  {
    label: '已接單',
    value: 'accepted',
    colorText: 'green',
    backgroundColor: 'rgba(0, 255, 0, 0.1)',
  },
  {
    label: '已拒單',
    value: 'abandoned',
    colorText: 'red',
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
  },
  {
    label: '客戶退單',
    value: 'clientCancelled',
    colorText: 'grey',
    backgroundColor: 'rgba(128, 128, 128, 0.1)',
  },
];
